var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowHeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "271228 2",
    clipPath: "url(#clip0_490_4448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.77482 5.38773L3.92866 0.541648C3.81657 0.429474 3.66695 0.367676 3.50741 0.367676C3.34787 0.367676 3.19824 0.429474 3.08616 0.541648L2.72927 0.898446C2.49704 1.13094 2.49704 1.50881 2.72927 1.74095L6.79871 5.8104L2.72475 9.88435C2.61267 9.99653 2.55078 10.1461 2.55078 10.3055C2.55078 10.4651 2.61267 10.6147 2.72475 10.7269L3.08164 11.0837C3.19381 11.1958 3.34335 11.2576 3.50289 11.2576C3.66243 11.2576 3.81206 11.1958 3.92414 11.0837L8.77482 6.23315C8.88718 6.12062 8.94889 5.97038 8.94853 5.81066C8.94889 5.65032 8.88718 5.50017 8.77482 5.38773Z",
    fill: "#222222",
    fillOpacity: 0.7
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_4448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.89,
    height: 10.89,
    fill: "white",
    transform: "translate(0.304688 0.368164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowHeadIcon);
export default __webpack_public_path__ + "static/media/rightArrowHeadIcon.2e0e1a11484840f7f7d599da64b2553b.svg";
export { ForwardRef as ReactComponent };